/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Calendar_Oauth_ReadyInputs */

const cs_settings_calendar_oauth_ready = /** @type {(inputs: Settings_Calendar_Oauth_ReadyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Propojení kalendáře je připravené. Připojit vás nechá přihlásit.`)
};

const en_settings_calendar_oauth_ready = /** @type {(inputs: Settings_Calendar_Oauth_ReadyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calendar connect is ready. Connect will let you sign in.`)
};

/**
* | output |
* | --- |
* | "Calendar connect is ready. Connect will let you sign in." |
*
* @param {Settings_Calendar_Oauth_ReadyInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const settings_calendar_oauth_ready = /** @type {((inputs?: Settings_Calendar_Oauth_ReadyInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Calendar_Oauth_ReadyInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_settings_calendar_oauth_ready(inputs)
	return cs_settings_calendar_oauth_ready(inputs)
});